exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.card-title[data-v-cc82ac92]{margin-left:33px\n}\n", "", {"version":3,"sources":["/app/frontend/src/screens/relatorios/components/os/TabelaProcesso.vue"],"names":[],"mappings":";AAoEA,6BACE,gBAAiB;CACjB","file":"TabelaProcesso.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n @import '@/assets/styles/_variables.scss';\n\n.card-title {\n  margin-left: 33px;\n }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cc82ac92","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/relatorios/components/os/TabelaProcesso.vue
// module id = IXIp
// module chunks = 11